import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { Tag, TAG_SIZE } from "components/Tags";
import { MEMBER_STATUS } from "constants/index";
import { colors } from "style";
import { Row } from "components/Containers";

/**
 * ApplicantStatus
 *
 * @param {Object} row
 */
const ApplicantStatus = ({ data }) => (
  <Row gap="0.5rem">
    <Tag size={TAG_SIZE.medium} color={getTagColorForProfileStatus(data?.profile?.status)}>
      <FormattedMessage id={`Missions.Applicants.ApplicanStatus.${data?.profile?.status}`} />
    </Tag>
    {[MEMBER_STATUS.assessing, MEMBER_STATUS.rejected, MEMBER_STATUS.reviewing, MEMBER_STATUS.sourced].includes(
      data?.profile?.status
    ) && (
      <div css={styles.status}>
        <Tag size={TAG_SIZE.medium} color={getTagColorForProfileStatus(data?.profile?.status)}>
          <FormattedMessage id={`Missions.Applicants.ApplicantProfileStatusDetailed.${data?.profile?.status}`} />
        </Tag>
      </div>
    )}
  </Row>
);

const PROFILE_STATUS_COLORS = {
  [MEMBER_STATUS.active]: colors.green,
  [MEMBER_STATUS.archived]: colors.red,
  [MEMBER_STATUS.inactive]: colors.red,
  [MEMBER_STATUS.rejected]: colors.red,
  [MEMBER_STATUS.assessing]: colors.grayAnatomyBase,
  [MEMBER_STATUS.reviewing]: colors.grayAnatomyBase,
  [MEMBER_STATUS.sourced]: colors.grayAnatomyBase,
};

const getTagColorForProfileStatus = (status) => PROFILE_STATUS_COLORS[status] || colors.grayAnatomyBase;

const styles = {
  status: css``,
};

ApplicantStatus.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ApplicantStatus;
